import React, { useState, useEffect } from "react";
import { generateClient } from 'aws-amplify/api';
import { listAvailabilities } from '../../graphql/queries';

const client = generateClient();

export default function Banner() {
  const [showBanner, setShowBanner] = useState(true);
  const [availability, setAvailability] = useState(null);

  useEffect(() => {
    const fetchAvailability = async () => {
      try {
        const result = await client.graphql({
          query: listAvailabilities,
          authMode: 'apiKey'
        });
        const records = result.data.listAvailabilities.items;
        if (records.length > 0) {
          const record = records[0];
          setAvailability(record.availableBeds);
          sessionStorage.setItem('availability', record.availableBeds);
        }
      } catch (error) {
        console.error("Error fetching availability:", error);
      }
    };

    const storedAvailability = sessionStorage.getItem('availability');
    if (storedAvailability) {
      setAvailability(storedAvailability);
    } else {
      fetchAvailability();
    }
  }, []);

  return (
    <>
      {showBanner && (
        <div className="relative isolate flex items-center justify-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5">
          {/* Gradient Decorations */}
          <div
            className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
            aria-hidden="true"
          >
            <div
              className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
              style={{
                clipPath:
                  "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
              }}
            />
          </div>

          <div
            className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
            aria-hidden="true"
          >
            <div
              className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
              style={{
                clipPath:
                  "polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)",
              }}
            />
          </div>

          {/* Text and Button */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <p className="text-sm leading-6 text-gray-900 flex-shrink-0">
              <strong className="font-semibold">{availability ? `${availability} Room${availability > 1 ? 's' : ''} Available` : 'Loading availability...'}</strong>
              <svg
                viewBox="0 0 2 2"
                className="mx-2 inline h-0.5 w-0.5 fill-current"
                aria-hidden="true"
              >
                <circle cx="1" cy="1" r="1" />
              </svg>
              Secure today
            </p>
            <a
              href="/contact"
              className="rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
            >
              Reserve <span aria-hidden="true">&rarr;</span>
            </a>
          </div>

          {/* Close Button */}
          <button
            type="button"
            className="absolute top-2 right-2 -m-3 p-3 focus-visible:outline-offset-[-4px]"
            onClick={() => setShowBanner(false)}
          >
          </button>
        </div>
      )}
    </>
  );
}